import React from "react";
import { Button, Card, CardContent, Divider, Fab, MenuItem, Pagination, Stack, Switch, TextField } from "@material-ui/core";
import {
  Typography,
  Box,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Chip,
} from "@material-ui/core";
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import AddIcon from '@mui/icons-material/Add';
import edit from '../../assets/images/edit.png';
import del from '../../assets/images/delete.png';
import print from '../../assets/images/print.png';
import { useNavigate } from "react-router-dom";
import { goEditDoctor, goToLogin, goToNewDoctor } from "../../routes/Coordinator";
import useForm from "../../hooks/useForm";
import axios from "axios";
import { useEffect, useState } from "react";
import { tableCellClasses } from '@mui/material/TableCell';
import { styled } from '@mui/material/styles';

const filters = [
  {
    value: "name",
    label: "Nome",
  },
  {
    value: "cpf_cnpj",
    label: "CPF/CNPJ",
  },
  {
    value: "syndicate_name",
    label: "CRM",
  },
  {
    value: "city",
    label: "Cidade",
  },
  {
    value: "state",
    label: "Estado",
  },
  {
    value: "phone",
    label: "Telefone",
  },
];

export const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: '#2A858B',
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));
export const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));
export const DivStyle = {
  overflowX: 'auto',
  width: '65vw',
  position: 'relative'
};
const DoctorsPage = () => {

  const [rows, setRows] = useState([])
  const [totalPages, setTotalPages] = useState(1)
  const navigate = useNavigate();
  const { form, onChangeForm, clear } = useForm({ field: "", value: "" });

  const handleChange = (event, page) => {
    let url = `${process.env.REACT_APP_BASE_URL}/doctors?page=${page}`

    if (form.field && form.value) {
      url = `${url}&${form.field}=${form.value}`
    }

    axios.get(url,
      {
        headers: {
          "access-token": localStorage.getItem("access-token"),
          "client": localStorage.getItem("client"),
          "expiry": localStorage.getItem("expiry"),
          "token-type": localStorage.getItem("token-type"),
          "uid": localStorage.getItem("uid"),
          "Content-Type": "application/json"
        }
      })
      .then(response => {
        setRows(response.data.doctors)
        setTotalPages(response.data.meta.total_pages)

      })
      .catch(erro => {
        Object.keys(erro.response.data).forEach((item) => {
          alert(erro.response.data[item]);
        });
      })
  };

  const Doctors = () => {
    let url = `${process.env.REACT_APP_BASE_URL}/doctors`

    if (form.field && form.value) {
      url = `${url}?${form.field}=${form.value}`
    }

    axios.get(url,
      {
        headers: {
          "access-token": localStorage.getItem("access-token"),
          "client": localStorage.getItem("client"),
          "expiry": localStorage.getItem("expiry"),
          "token-type": localStorage.getItem("token-type"),
          "uid": localStorage.getItem("uid"),
          "Content-Type": "application/json"
        }
      })
      .then(response => {
        setRows(response.data.doctors)
        setTotalPages(response.data.meta.total_pages)

      })
      .catch(erro => {
        Object.keys(erro.response.data).forEach((item) => {
          alert(erro.response.data[item]);
        });
        if (erro.response.status === 401) {
          goToLogin(navigate)
        }
      })
  }
  useEffect(() => {
    Doctors()
  }, [])

  const DeleteDoctors = (id) => {
    let url = `${process.env.REACT_APP_BASE_URL}/doctors/${id}`

    axios.delete(url,
      {
        headers: {
          "access-token": localStorage.getItem("access-token"),
          "client": localStorage.getItem("client"),
          "expiry": localStorage.getItem("expiry"),
          "token-type": localStorage.getItem("token-type"),
          "uid": localStorage.getItem("uid"),
          "Content-Type": "application/json"
        }
      })
      .then(response => {
        alert("Médico deletado com sucesso.")
        Doctors()

      })
      .catch(erro => {
        Object.keys(erro.response.data).forEach((item) => {
          alert(erro.response.data[item]);
        });
      })
  }
  const EditActive = (active, id) => {
    let url = `${process.env.REACT_APP_BASE_URL}/doctors/${id}`
    axios.put(url, { doctor: { active } },
      {
        headers: {
          "access-token": localStorage.getItem("access-token"),
          "client": localStorage.getItem("client"),
          "expiry": localStorage.getItem("expiry"),
          "token-type": localStorage.getItem("token-type"),
          "uid": localStorage.getItem("uid"),
          "Content-Type": "application/json"
        }
      })
      .then(response => {
        Doctors()
      })
      .catch(erro => {
        Object.keys(erro.response.data).forEach((item) => {
          alert(erro.response.data[item]);
        });
      })
  }
  const handleChangeChecked = (active, id) => {
    EditActive(active, id)
  };
  const DeleteButton = (id) => {
    let resposta = window.confirm("Deseja remover esse registro?")
    if (resposta === true) {
      DeleteDoctors(id)
    }
  };
  return (
    <Box>
      <Card variant="outlined">
        <CardContent>
          <Typography variant="h3" sx={{ mb: 2 }}>Médicos</Typography>
          <Divider />
          <CardContent
            sx={{
              padding: "30px"
            }}
          >
            <form>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: 'space-between',
                  alignItems: 'center'
                }}
              >
                <Box>
                  <TextField
                    id="function"
                    name="field"
                    select
                    label="Selecione"
                    onChange={onChangeForm}
                    value={form.field}
                    type={"field"}
                    size="small"
                    sx={{
                      width: 150,
                    }}
                  >
                    {filters.map((option) => (
                      <MenuItem key={option.value} value={option.value}>
                        {option.label}
                      </MenuItem>
                    ))}
                  </TextField>
                  <TextField
                    name={"value"}
                    id="outlined-required"
                    onChange={onChangeForm}
                    value={form.value}
                    type={"value"}
                    size="small"
                    sx={{
                      width: 300
                    }}
                  />
                  <Button
                    onClick={Doctors}
                    variant="contained"
                    color="primary"
                    size="large"
                  >
                    <SearchOutlinedIcon />
                    <Typography
                      sx={{ ml: 1 }}
                    >
                      Pesquisar
                    </Typography>
                  </Button>
                </Box>
                <Box>
                  <Button
                    variant="contained"
                    color="success"
                    size="large"
                    sx={{ lineHeight: 1 }}
                    onClick={() => goToNewDoctor(navigate)}
                  >
                    <AddIcon />
                    <Typography
                      sx={{ ml: 1 }}
                    >
                      Cadastrar
                    </Typography>
                  </Button>
                </Box>
              </Box>
            </form>
          </CardContent>
          <Box
            sx={{
              overflow: {
                xs: "auto",
                sm: "unset",
              },
            }}
          >
            <Table
              aria-label="simple table"
              sx={{
                mt: 3,
              }}
            >
                <TableHead>
                  <TableRow>
                    <TableCell>
                      <Typography color="textSecondary" variant="h6">
                        Nome
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <Typography color="textSecondary" variant="h6">
                        CPF/CNPJ
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <Typography color="textSecondary" variant="h6">
                        CRM
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <Typography color="textSecondary" variant="h6">
                        Cidade
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <Typography color="textSecondary" variant="h6">
                        Estado
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <Typography color="textSecondary" variant="h6">
                        Telefone
                      </Typography>
                    </TableCell>
                    <TableCell align="center">
                      <Typography color="textSecondary" variant="h6">
                        Ativo
                      </Typography>
                    </TableCell>
                    <TableCell align="center">
                      <Typography >
                      </Typography>
                    </TableCell>
                    <TableCell align="center">
                      <Typography >
                      </Typography>
                    </TableCell>
                    <TableCell align="center">
                      <Typography >
                      </Typography>
                    </TableCell>

                  </TableRow>
                </TableHead>
                <TableBody>
                  {rows.map((row) => (
                    <StyledTableRow key={row.id}>
                      <StyledTableCell align="left">
                        {row.name}
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        {row.cpf_cnpj}
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        {row.syndicate_name}
                      </StyledTableCell>
                      <StyledTableCell align="center">
                          {row.city}
                          </StyledTableCell>
                          <StyledTableCell align="center">
                          {row.state}
                          </StyledTableCell>
                          <StyledTableCell align="center">
                          {row.phone}
                          </StyledTableCell>
                          <StyledTableCell align="center">
                        <Switch size="small" checked={row.active} onChange={(e) => handleChangeChecked(e.target.checked, row.id)} />
                      </StyledTableCell>
                      {row.signature &&

                        <StyledTableCell align="center" width={5}><a target={'_blank'} href={`${process.env.REACT_APP_BASE_URL}${row.signature}`}><img src={print}></img></a></StyledTableCell>
                      }
                      {!row.signature &&

                        <StyledTableCell></StyledTableCell>
                      }
                      <StyledTableCell align="center" sx={{ width: 2, padding: 0 }}>
                        <Button onClick={() => goEditDoctor(navigate, row.id)}><img src={edit}></img></Button>
                      </StyledTableCell>
                      <StyledTableCell align="center" sx={{ width: 2, padding: 0 }}>
                        <Button onClick={() => DeleteButton(row.id)}><img src={del}></img></Button>
                      </StyledTableCell>
                    </StyledTableRow>

                  ))}
                </TableBody>
            </Table>
            <Box
              sx={{
                marginTop: 5,
                display: 'flex',
                justifyContent: "flex-end"
              }}
            >
              <Stack spacing={2}>
                <Pagination count={totalPages} onChange={handleChange} variant="outlined" color="primary" />
              </Stack>
            </Box>
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
};

export default DoctorsPage;